/**
 * Custom `Error` thrown manually thrown within `loaders` and `actions`
 */
export class LoaderActionError extends Error {
  public status: number;

  constructor(status: number, message?: string) {
    super();
    this.name = 'LoaderActionError';
    this.status = status;
    this.message = `HTTP ${this.status}: ${
      message ?? 'no custom error message provided'
    }`;
  }
}

/**
 * Check if the given error is a LoaderActionError thrown from an action/loader
 */
export function isLoaderActionError(
  error: unknown
): error is LoaderActionError {
  return (
    error != null &&
    typeof error === 'object' &&
    'name' in error &&
    error.name === 'LoaderActionError'
  );
}
